// StarRating — shows filled/partial/empty stars in gold
// Usage: <StarRating rating={3.7} count={12} size="sm" />
export default function StarRating({ rating, count, size = "sm", interactive = false, onRate }) {
  const sz = size === "lg" ? "w-6 h-6" : "w-4 h-4";
  const textSz = size === "lg" ? "text-base" : "text-xs";

  if (!rating && !interactive) return null;

  return (
    <span className={`inline-flex items-center gap-1 ${textSz}`} aria-label={`${rating} out of 5 stars`}>
      <span className="inline-flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => {
          const fill = Math.min(1, Math.max(0, (rating || 0) - (star - 1)));
          const pct = Math.round(fill * 100);
          return (
            <span
              key={star}
              className={interactive ? "cursor-pointer" : ""}
              onClick={() => interactive && onRate && onRate(star)}
              style={{ position: "relative", display: "inline-block" }}
            >
              {/* Empty star */}
              <svg className={sz} viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                  stroke="#D4A017"
                  strokeWidth="1.5"
                  fill="#e5e7eb"
                />
              </svg>
              {/* Filled star overlay */}
              {pct > 0 && (
                <svg
                  className={sz}
                  viewBox="0 0 24 24"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    clipPath: `inset(0 ${100 - pct}% 0 0)`,
                  }}
                >
                  <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    fill="#F59E0B"
                    stroke="#D4A017"
                    strokeWidth="1.5"
                  />
                </svg>
              )}
            </span>
          );
        })}
      </span>
      {rating && (
        <span className="text-muted-foreground font-mono">
          {rating.toFixed(1)}{count != null ? ` (${count})` : ""}
        </span>
      )}
    </span>
  );
}
